module.exports = __webpack_public_path__ + "static/media/list.af6061ec.svg";